export const FUNNEL_COLUMNS_UI: { key: string; label: string; statuses: string[] }[] = [
  { key: "new", label: "Новый заказ", statuses: ["NEW", "ASSIGNED"] },
  { key: "awaiting_payment", label: "Ожидают оплаты", statuses: ["AWAITING_PAYMENT"] },
  { key: "payment_review", label: "Проверить оплату", statuses: ["PAYMENT_REVIEW", "PAYMENT_NOT_FOUND"] },
  { key: "awaiting_code", label: "Ожидают код", statuses: ["PAYMENT_CONFIRMED", "AWAITING_CODE", "CODE_SUBMITTED"] },
  { key: "code_review", label: "Проверить код", statuses: ["CODE_REVIEW", "INVALID_CODE"] },
  { key: "completed", label: "Завершено", statuses: ["COMPLETED"] },
];
